<template>
  <div id="admin-work-license-setting">
    <!-- 上岗证设置 -->
    <diy_table
      :loading="loading"
      :tipData="tipData"
      :active="active"
      :searchData="searchData"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      @handleClickTop="handleClickTop"
      @showActive="showActive"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as workLicenseData from "./js/work_license.js";
import * as base from "../js/base.js";
export default {
  data() {
    return {
      tipData: [
        { text: "工种/岗位", key: "station" },
        { text: "考核意见", key: "examOpinion" },
        { text: "扣分项", key: "deduct" },
      ],
      loading: false,
      active: "station",
      searchData: workLicenseData.getSearchData("workLicenseSetting"),
      buttonList: workLicenseData.getTopButArray("workLicenseStationSetting"),
      tableMenu: workLicenseData.getTableMenu("workLicenseStationSetting"),
      tableData: [],
      tableButton: workLicenseData.getTableBUttonList(
        "workLicenseStationSetting"
      ),

      tempTip: {}, // 临时标签
      options: {
        professional: [],
      },

      dialogData: {
        flag: false,
        title: "添加子部门",
        width: "30%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_add_child_dep" },
          { text: "取消", active: "cancel" },
        ],
      },

      allAuthorityList: [],
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  考试管理 32
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "34" },
        });
        this.allAuthorityList = resultData;
      } catch (error) {}
    },
    initTable(data) {
      try {
        this.loading = true;
        this.tableData = [];
        setTimeout(async () => {
          let requestData = {};
          let resultData = {};
          this.tableMenu = [];
          if (this.active == "station" || this.active == "examOpinion") {
            // 获取工种/岗位的配置项或考核意见
            this.buttonList = workLicenseData.getTopButArray(
              "workLicenseStationSetting"
            );
            this.tableButton = workLicenseData.getTableBUttonList(
              "workLicenseStationSetting"
            );
            this.tableMenu = workLicenseData.getTableMenu(
              "workLicenseStationSetting"
            );
            requestData = {
              type: this.active,
            };
            requestData = this.$baseData.array2json(
              data.searchData,
              requestData
            );
            resultData = await this.$request({
              url: "/dictionaries/getListByType",
              method: "post",
              data: requestData,
            });
            this.tableData = resultData;
          } else {
            this.buttonList = workLicenseData.getTopButArray(
              "workLicenseDeductionSetting"
            );
            this.tableButton = workLicenseData.getTableBUttonList(
              "workLicenseDeductionSetting"
            );
            this.tableMenu = workLicenseData.getTableMenu(
              "workLicenseDeductionSetting"
            );
            requestData = {
              pageSize: 1000,
              currentPage: 1,
            };
            requestData = this.$baseData.array2json(
              data.searchData,
              requestData
            );
            resultData = await this.$request({
              url: "/workDeduction/getAllDeductWorkLicenseConfigList",
              method: "post",
              data: requestData,
            });
            this.tableData = resultData.tableData;
          }
          if (this.active == "examOpinion") {
            this.buttonList = workLicenseData.getTopButArray(
              "workLicenseExamOpinionSetting2"
            );
          }
          // this.buttonList = base.returnAllButton(
          //   this.buttonList,
          //   this.allAuthorityList,
          //   "name"
          // );
          // this.tableButton = base.returnAllButton(
          //   this.tableButton,
          //   this.allAuthorityList,
          //   "text"
          // );
          // 在数据更新后执行
          this.$nextTick(() => {
            // myTable是表格的ref属性值
            if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
              this.$refs.singleTable.doLayout();
            }
          });

          this.loading = false;
        }, 500);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    handleClickTop(active) {
      switch (active) {
        case "create_station":
          // 创建工种/岗位标签
          this.tempTip = { id: "" };
          this.dialogData.title =
            this.active == "station" ? "添加工种/岗位" : "添加考核意见";
          this.dialogData.dialogData = [
            { title: "名称", type: "input", value: "", key: "mean" },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_add_station" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "create_deduction":
          // 创建扣分项标签
          this.tempTip = { id: "" };
          this.dialogData.title = "添加扣分项";
          this.dialogData.dialogData = [
            { title: "扣分描述", type: "input", value: "", key: "name" },
            { title: "分值", type: "input", value: "", key: "grade" },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_add_deduction" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;

        default:
          break;
      }
    },
    handleClick(data) {
      this.tempTip = JSON.parse(JSON.stringify(data.item));
      switch (data.active) {
        case "edit_station":
          //   编辑标签
          this.dialogData.title =
            this.active == "station" ? "编辑工种/岗位" : "编辑考核意见";
          this.dialogData.dialogData = [
            {
              title: "名称",
              type: "input",
              value: this.tempTip.mean,
              key: "mean",
            },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_add_station" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "edit_deduction":
          //   编辑标签
          this.dialogData.title = "编辑扣分项";
          this.dialogData.dialogData = [
            {
              title: "扣分描述",
              type: "input",
              value: this.tempTip.name,
              key: "name",
            },
            {
              title: "分值",
              type: "input",
              value: this.tempTip.grade,
              key: "grade",
            },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_add_deduction" },
            { text: "取消", active: "cancel" },
          ];
          this.dialogData.flag = true;
          break;
        case "delete":
          //   删除标签
          this.$confirm("此操作将永久删除该标签, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let url =
                this.active == "station"
                  ? "/dictionaries/delDic" // 删除工种/岗位
                  : "/workDeduction/deleteDeductWorkLicenseConfig"; // 删除扣分项
              let resultData = await this.$request({
                url: url,
                method: "post",
                data: { id: this.tempTip.id },
              });
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
          break;

        default:
          break;
      }
    },
    /**
     * 弹出框操作事件
     */
    async dialogOper(active) {
      try {
        let requestData = {};
        let resultData = {};
        switch (active) {
          case "makesure_add_station":
            // 编辑或添加工种/岗位标签
            requestData = {
              id: this.tempTip.id,
              type: this.active,
            };
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            if (requestData.mean == "") {
              throw { message: "名称不可为空!" };
            }
            resultData = await this.$request({
              url: "/dictionaries/saveDic",
              method: "post",
              data: requestData,
            });
            this.$message({
              message: "添加成功!",
              type: "success",
              duration: 1000,
            });
            this.dialogData.flag = false;
            await this.initTable({ searchData: this.searchData });
            break;
          case "makesure_add_deduction":
            // 编辑或添加扣分项标签
            requestData = {
              id: this.tempTip.id,
              type: this.active,
            };
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            if (requestData.name == "") {
              throw { message: "名称不可为空!" };
            }
            if (requestData.grade == "") {
              throw { message: "分值不可为空!" };
            }
            if (!this.$baseData.judgeStringIsNumber(requestData.grade)) {
              throw { message: "分值只能数字!" };
            }
            resultData = await this.$request({
              url: "/workDeduction/saveOrUpdateDeductWorkLicenseConfig",
              method: "post",
              data: requestData,
            });
            this.$message({
              message: "添加成功!",
              type: "success",
              duration: 1000,
            });
            this.dialogData.flag = false;
            await this.initTable({ searchData: this.searchData });
            break;
          case "cancel":
            // 关闭弹出框
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
      if (this.active == "station" || this.active == "examOpinion") {
        this.buttonList = workLicenseData.getTopButArray(
          "workLicenseStationSetting"
        );
        this.tableButton = workLicenseData.getTableBUttonList(
          "workLicenseStationSetting"
        );
        this.tableMenu = workLicenseData.getTableMenu(
          "workLicenseStationSetting"
        );
      } else {
        this.buttonList = workLicenseData.getTopButArray(
          "workLicenseDeductionSetting"
        );
        this.tableButton = workLicenseData.getTableBUttonList(
          "workLicenseDeductionSetting"
        );
        this.tableMenu = workLicenseData.getTableMenu(
          "workLicenseDeductionSetting"
        );
      }
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.initTable({ searchData: this.searchData });
  },
  // 组件被激活时，重新渲染
  activated() {
    this.$nextTick(() => {
      this.$refs && this.$refs.singleTable && this.$refs.singleTable.doLayout();
    });
  },
};
</script>

<style lang="less" scoped>
#admin-work-license-setting {
  width: 100%;
  height: 100%;
}
</style>